module.exports = __webpack_public_path__ + "img/csv_read_documentation.70d0e630.png";